const SAFE_URL_PROTOCOLS = ['http:', 'https:'];

/**
 * Valida que una URL use un esquema seguro (http/https) antes de usarla en
 * `window.open` / `window.location.href`. Bloquea esquemas como `javascript:`
 * o `data:` que permitirían XSS si la URL proviene de datos no confiables.
 */
export function isSafeImageUrl(url: string | null | undefined): boolean {
  if (!url) return false;
  try {
    const parsed = new URL(url, window.location.origin);
    return SAFE_URL_PROTOCOLS.includes(parsed.protocol);
  } catch {
    return false;
  }
}
